import $ from 'jquery';
import ConditionallyShownContent from '../modules/conditionally-shown-content';

function initializeConditionallyShownContent() {
  $('.js-conditional-content-container').each((i, el) => {
    new ConditionallyShownContent($(el));
  });
}

export default initializeConditionallyShownContent;
